import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { callSvcAxiosInstance } from "@/constants";
import { ENV } from "@/constants/env";
import { CreateFeedbackPayload } from "@/types/feedback.types";

export const feedbackKeys = {
    all: ["feedback"] as const,
};

export const feedbackEndpoints = {
    createFeedback: `${ENV.CALL_SVC_URL}/chatbot/slack/notify`,
};

const createFeedback = async (payload: CreateFeedbackPayload) => {
    const response = await callSvcAxiosInstance.post(feedbackEndpoints.createFeedback, payload);
    return response.data;
};

export const useCreateFeedback = () => {
    const { t } = useTranslation();

    return useMutation({
        mutationFn: createFeedback,
        onSuccess: () => {
            toast.success(t("error_report_success"));
        },
        onError: (error) => {
            console.error("Failed to submit feedback:", error);
            toast.error(t("error_report_failed"));
        },
    });
};
